import { getLastMessage } from './conversationHelper';
import { getConversationOrderId } from './conversationOrder';
import { getEmailTalonProjection } from './emailDisplayContent';
import { getWhatsAppDisplayContent } from './whatsappMessagePresentation';
import { whatsappRevocation } from './whatsappRevocation';

const emailOf = message =>
  (message?.content_attributes ?? message?.contentAttributes)?.email;

function getEmailReply(message) {
  return getEmailTalonProjection(emailOf(message));
}

function fragmentText(fragment) {
  fragment.querySelectorAll('style, script').forEach(node => node.remove());
  fragment
    .querySelectorAll(
      'br, p, div, li, td, th, h1, h2, h3, h4, h5, h6, blockquote, pre'
    )
    .forEach(node => {
      node.prepend(document.createTextNode(' '));
      node.append(document.createTextNode(' '));
    });
  return fragment.textContent.replace(/\s+/g, ' ').trim();
}

/** Display only: keep the stored body and existing WhatsApp presentation intact. */
export function getMessagePreviewContent(message = {}) {
  if (!emailOf(message)) return getWhatsAppDisplayContent(message);

  const projection = getEmailReply(message);
  if (!projection.ready) {
    return projection.status === 'pending'
      ? '正在识别邮件正文…'
      : '邮件正文待确认';
  }
  return (
    projection.replyText.replace(/\s+/g, ' ').trim() ||
    (message.attachments?.length ? '附件' : '未提取到新的回复正文')
  );
}

function findOrderId(content = '', plainText = false) {
  const fragment = document.createElement('template');
  if (plainText) {
    fragment.content.append(document.createTextNode(content || ''));
  } else {
    fragment.innerHTML = content || '';
    // Keep the existing non-email order preview boundary. Email body extraction
    // above uses only Talon's plain-text projection and never these selectors.
    fragment.content
      .querySelectorAll(
        'blockquote, .gmail_quote, .gmail_quote_container, .OutlookQuote, .email-quote, .quoted-text, [data-email-quote="history"]'
      )
      .forEach(node => node.remove());
  }
  const text = fragmentText(fragment.content).replace(
    /\b[a-z][a-z\d+.-]*:\/\/\S+|\bwww\.\S+/gi,
    ' '
  );
  return (
    text.match(
      /(?<![\p{L}\p{N}_/=?&#%+.-])\d{3}-\d{7}-\d{7}(?![\p{L}\p{N}_/=?&#%+-]|\.[\p{L}\p{N}])/u
    )?.[0] || ''
  );
}

/** Preview label only; this fallback never changes linked-order authority. */
export function getConversationPreviewOrderId(conversation = {}) {
  const linkedOrderId = getConversationOrderId(conversation);
  if (linkedOrderId) return linkedOrderId;

  const normalizeMessage = message =>
    message && {
      ...message,
      message_type: message.message_type ?? message.messageType,
      created_at: message.created_at ?? message.createdAt,
    };
  const message =
    getLastMessage({
      messages: (conversation.messages || []).map(normalizeMessage),
      last_non_activity_message: normalizeMessage(
        conversation.last_non_activity_message ??
          conversation.lastNonActivityMessage
      ),
    }) || {};
  if (
    whatsappRevocation(message.content_attributes ?? message.contentAttributes)
  ) {
    return '';
  }
  const attrs = conversation.custom_attributes ?? conversation.customAttributes;
  return (
    findOrderId(
      emailOf(message)
        ? getEmailReply(message).replyText
        : getWhatsAppDisplayContent(message),
      Boolean(emailOf(message))
    ) ||
    findOrderId(emailOf(message)?.subject) ||
    findOrderId(attrs?.email?.subject)
  );
}
